import { GoalType } from '../../graphql/generated';
import { isNumber } from '../../util/types';
import { IconSize } from '../icons';
import { getGoalBaseConfig } from './baseConfigs';

export type GoalIconSize = 'md' | 'lg' | 'xl';

export interface GoalIconBaseProps {
    type: GoalType;
    progress: number | null;
    size?: GoalIconSize;
    inverted?: boolean;
    filled?: boolean;
    fill?: string;
}

export const GOAL_ICON_VIEWBOX = 100;
const SIZE_PROPS: Record<
    GoalIconSize,
    { strokeWidth: number; size: number; iconSize: IconSize }
> = {
    xl: {
        strokeWidth: (GOAL_ICON_VIEWBOX / 32) * 1.5,
        size: 32,
        iconSize: 'sm',
    }, // appears as 1.5 strokeWidth
    lg: {
        strokeWidth: (GOAL_ICON_VIEWBOX / 24) * 1.5,
        size: 24,
        iconSize: 'xs',
    }, // appears as 1.5 strokeWidth
    md: {
        strokeWidth: (GOAL_ICON_VIEWBOX / 20) * 1.5,
        size: 20,
        iconSize: 'xs',
    }, // appears as 1.5 strokeWidth
};

export const getGoalIconSizeProps = (size: GoalIconSize) => SIZE_PROPS[size];

export const getGoalIconBaseParams = ({
    type,
    progress,
    size = 'lg',
    filled,
    inverted,
}: GoalIconBaseProps): {
    strokeWidthPx: number;
    sizePx: number;
    rPx: number;
    isComplete: boolean;
    determinant: number;
    strokeDasharray: string;
    stroke: string;
    fill: string;
    iconColor: string;
    iconSize: IconSize;
    loading: false;
} => {
    const config = getGoalBaseConfig(type);
    const color = config.color;
    const sizeProps = getGoalIconSizeProps(size);
    const strokeWidthPx = sizeProps.strokeWidth;
    const sizePx = sizeProps.size;
    const rPx = GOAL_ICON_VIEWBOX / 2 - sizeProps.strokeWidth;
    const iconSize = sizeProps.iconSize;

    const isComplete = filled || (isNumber(progress) && progress >= 100);
    const determinant = (progress ?? 100) * 2.64;
    const strokeDasharray = `${determinant} ${264 - determinant}`;

    const stroke = inverted ? 'white' : color;
    const fill = isComplete ? color : 'transparent';
    const iconColor = isComplete || inverted ? 'white' : color;

    return {
        strokeWidthPx,
        sizePx,
        rPx,
        isComplete,
        determinant,
        strokeDasharray,
        stroke,
        fill,
        iconColor,
        iconSize,
        loading: false,
    };
};
